import {
	OPERATOR_LOGIN_SUCCESS,
	OPERATOR_LOGIN_ERROR,
	OPERATOR_LOGIN_START,
	CLEAR_OPERATOR_PREVIOUS_REDUCER,
} from "Constant";

const initialState = {
	loading: false,
	data: null,
};

export default function OperatorLoginReducer(
	state = { ...initialState },
	action
) {
	switch (action.type) {
		case OPERATOR_LOGIN_START:
			return {
				...state,
				loading: true,
			};
		case OPERATOR_LOGIN_SUCCESS:
			return {
				...state,
				data: action.payload,
				loading: false,
			};
		case OPERATOR_LOGIN_ERROR:
			return {
				...state,
				loading: false,
				message: action.error.message,
			};

		case CLEAR_OPERATOR_PREVIOUS_REDUCER:
			return {
				...state,
				loading: false,
				data: null,
			};

		default:
			return state;
	}
}
